




import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

import Panel from "@/components/base/Panel.vue";

const couponModule = namespace("coupon");

@Component({
	components: {
		Panel
	}
})
export default class CouponAdd extends Vue {}
